import ActionDrawer from "@/components/ActionDrawer";
import MerchCard from "@/components/MerchCard";
import ExperienceCard from "@/components/ExperienceCard";
import ImageCarousel from "@/components/ImageCarousel";
import PollContainer from "@/components/PollContainer";
import SongCard from "@/components/SongCard";
import { renderTextWithMentions } from "@/utils/mentions";
import { formatDate } from "@/utils/time";
import { PushPin, ScheduleSend, Sms, Verified } from "@mui/icons-material";
import {
  Avatar,
  Box,
  CardMedia,
  Chip,
  Stack,
  Typography,
  Card,
} from "@mui/material";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import { useActiveSubscribers } from "@/services/data";

export default function ScheduledNoteCard({ content }) {
  const navigate = useNavigate();
  const { data: activeSubscribers } = useActiveSubscribers();
  return (
    <Box sx={{ mb: 4 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ ml: 5 }}>
        <ScheduleSend sx={{ fontSize: "20px", mr: 0.5 }} color="primary" />
        <Typography variant="caption" sx={{ color: "lightgray" }}>
          {formatDate(content.live)}
        </Typography>
      </Stack>
      <Box id={content.key} sx={{ mb: 2, display: "flex" }}>
        <Avatar
          src={content.owner.meta.profile}
          sx={{ width: 40, height: 40, marginRight: 2, marginTop: 1 }}
          onClick={() => navigate("/" + content.owner.key)}
        />

        <Box id="post-content-container" style={{ flex: 1 }}>
          <Box
            id="post-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              id="user-detail"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              <Typography
                variant="body"
                style={{ marginRight: "5px", fontWeight: "bold" }}
              >
                {content.owner.name}
              </Typography>

              <Verified
                color={content.owner.verified ? "secondary" : "disabled"}
                style={{ fontSize: "15px", marginRight: "5px" }}
              />
            </Box>

            <ActionDrawer content={content} />
          </Box>

          <Box id="post-content" style={{ marginTop: "-5px" }}>
            {content.meta.text != "" && (
              <Box
                style={{ wordWrap: "break-all", whiteSpace: "pre-wrap" }}
                sx={{ mb: 2 }}
              >
                {renderTextWithMentions(content.meta.text)}
              </Box>
            )}

            {content.type == "carousel" && (
              <Box sx={{ borderRadius: "20px" }}>
                <ImageCarousel
                  content={content}
                  height={300}
                  borderRadius={"20px"}
                />
              </Box>
            )}

            {content.type == "poll" && <PollContainer content={content} />}

            {content.type == "audio" && (
              <Box>
                <SongCard content={content} />
                <Typography variant="body1" sx={{ my: 1, fontWeight: "600" }}>
                  {content.meta.title}
                </Typography>
              </Box>
            )}

            {content.type === "image" && (
              <Box>
                <Box style={{ overflow: "hidden", borderRadius: "10px" }}>
                  <CardMedia
                    component="img"
                    src={content.meta.url}
                    style={{
                      borderRadius: "10px",
                      pointerEvents: "none", // Additional protection
                    }}
                  />
                </Box>
              </Box>
            )}

            {content.type === "experience" && (
              <ExperienceCard content={content} />
            )}

            {content.type === "merch" && <MerchCard content={content} />}

            {content.type == "video" && (
              <Card style={{ borderRadius: "20px" }}>
                <Box
                  style={{
                    overflow: "hidden",
                    borderRadius: "10px",
                    aspectRatio: "1/1",
                  }}
                  onClick={(e) => handleClickVideo(e)}
                >
                  <ReactPlayer
                    url={content.meta.url}
                    // light={content.meta.cover}
                    light={content.meta.cover}
                    playing
                    controls
                    width="100%"
                    height="100%"
                    // style={{ filter: "blur(15px)" }}
                    // onContextMenu={preventLongPressMenu}
                  />
                </Box>
              </Card>
            )}
          </Box>

          <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
            {content.meta.featured && (
              <Chip
                icon={<PushPin sx={{ fontSize: 16, color: "#04FFFF" }} />}
                label="Featured"
                color="secondary"
                sx={{ mt: 1 }}
                variant="outlined"
              />
            )}
            {content.meta.notification && (
              <Chip
                icon={<Sms sx={{ fontSize: 16, color: "#04FFFF" }} />}
                label={`SMS Scheduled (${activeSubscribers?.count || 0})`}
                color="secondary"
                sx={{ mt: 1 }}
                variant="outlined"
              />
            )}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
